import { render, staticRenderFns } from "./AddClass.vue?vue&type=template&id=727e9c88&scoped=true"
import script from "./AddClass.vue?vue&type=script&lang=js"
export * from "./AddClass.vue?vue&type=script&lang=js"
import style0 from "./AddClass.vue?vue&type=style&index=0&id=727e9c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e9c88",
  null
  
)

export default component.exports